export const COLUMNSTORE_TIP =
    "Columnstore data is highly compressed for more efficient storage. The actual compression amount is determined by both the cardinality and the data types of your columns.";

export const HIGH_AVAILABILITY_TIP = `When enabled, a replica of each data partition is maintained on a different leaf node.`;

export const ROW_COUNT_TIP =
    "This value may be affected by recent deletions and uncomitted transactions.";
